export default __webpack_public_path__ + "static/media/Doit(sinfondo).2554251a.png";